<table mat-table matSort  [dataSource]="dataSource" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- serial_no Column -->
    <ng-container matColumnDef="host">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> HOST </th>
      <td mat-cell *matCellDef="let element"> {{element.host}} </td>
    </ng-container>
  
    <!-- IP Column -->
    <ng-container matColumnDef="port">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> PORT </th>
      <td mat-cell *matCellDef="let element"> {{element.port}} </td>
    </ng-container>

    <!-- IP Column -->
    <ng-container matColumnDef="start_tls_enable">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> START TLS ENABLE </th>
        <td mat-cell *matCellDef="let element"> {{element.start_tls_enable}} </td>
      </ng-container>
  
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="auth">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>AUTH </th>
      <td mat-cell *matCellDef="let element"> {{element.auth}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NAZWA UŻYTKOWNIKA</th>
        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
      </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="password">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>HASŁO</th>
        <td mat-cell *matCellDef="let element"> {{element.password}} </td>
      </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="account_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TYP</th>
        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
      </ng-container>
      
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
